import React from 'react';
import { Table, Button, Tag, Alert } from 'antd';
import { UpOutlined, DownOutlined } from '@ant-design/icons';

import SingleProductView from './SingleProductView';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

class ReportTable extends React.Component {
    expandedRowRender = (record) => {
        const { exportSingleProduct, isDemo, country } = this.props;
        console.log(this.props);
        return <SingleProductView
            record={record}
            country={country}
            exportSingleProduct={exportSingleProduct}
            isDemo={isDemo}
        />
    };

    getProductStatus = (item) => {
        if (item.is404)
            return (
                <Tag className="report-table-tag" color="#f50">
                    Page 404
                </Tag>
            );
        if (!item.isAvailable)
            return (
                <Tag className="report-table-tag" color="#f50">
                    Unavailable
                </Tag>
            );
        if (item.isOutOfStock)
            return (
                <Tag className="report-table-tag" color="#f50">
                    Out Of Stock
                </Tag>
            );
        if (item.scraperStatus !== 'done') return 'Status Unavailable';
        return (
            <Tag className="report-table-tag" color="#87d068">
                Available
            </Tag>
        );
    };

    truncate = (str) => (str.length > 100 ? `${str.substring(0, 100)}..` : str);

    getFilters = (values) => values.map((v) => ({ text: v, value: v }));

    getColumns = () => {
        return [
            {
                title: 'Image',
                dataIndex: 'image',
                key: 'image',
                width: 100,
                // height: 70,
                className: 'report-table-image-container',
                render: (item, record) => {
                    if (record.is404 || !record.imageUrl) return <span>Image Unavailable</span>;
                    if (this.props.isDemo)
                        return <img className="report-table-image" src={record.imageUrl} alt={record.name} />;
                    return (
                        <LazyLoadImage
                            alt={record.name}
                            effect="blur"
                            src={record.imageUrl}
                            className="report-table-image"
                        />
                    );
                }
            },
            {
                title: 'Product Name',
                dataIndex: 'name',
                key: 'name',
                width: 300,
                className: 'report-table-name-container',
                render: (item, record) => (
                    <a href={record.to} target="_blank" rel="noopener noreferrer">
                        {record.is404 || !record.name ? (
                            <span>Name Unavailable</span>
                        ) : (
                                record.name && this.truncate(record.name)
                            )}
                    </a>
                ),
                sorter: (a, b) => {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                }
            },
            {
                title: 'Product Status',
                dataIndex: 'is404',
                key: 'is404',
                className: 'report-table-status-container',
                render: (item, record) => this.getProductStatus(record),
                // sorter: (a, b) => a.age - b.age,
                // filters: this.getFilters(['']),
                // onFilter: (value, record) => {},
            },
            {
                title: 'Reviews',
                dataIndex: 'reviewScore',
                key: 'reviewScore',
                className: 'report-table-reviews-container',
                render: (item, record) =>
                    record.reviewCount ? (
                        <span>
                            {record.reviewScore} {record.reviewCount && `(${record.reviewCount} reviews)`}
                        </span>
                    ) : (<span>None</span>),
                sorter: (a, b) => {
                    if (a.reviewScore < b.reviewScore) {
                        return -1;
                    }
                    if (a.reviewScore > b.reviewScore) {
                        return 1;
                    }
                    return 0;
                }
            },
            {
                title: 'Affiliate Id',
                dataIndex: 'affiliateId',
                key: 'affiliateId',
                className: 'report-table-affId-container',
                render: (item, record) =>
                    record.affiliateId ? <Tag color="blue">{record.affiliateId}</Tag> : <Tag color="volcano">missing</Tag>
                // sorter: (a, b) => a.age - b.age,
                // filters: [
                //   {
                //     text: 'Joe',
                //     value: 'Joe',
                //   },
                //   {
                //     text: 'John',
                //     value: 'John',
                //   },
                // ],
                // onFilter: (value, record) => {},
            },
            !this.props.isDemo && {
                title: 'Referring Pages',
                dataIndex: 'links',
                key: 'links',
                className: 'report-table-links-container',
                render: (item, record) => <span>{record && record.from && record.from.length}</span>
            }
        ].filter((f) => !!f);
    };

    expandIcon = (props) => {
        const tooltipText = (
            <span>
                Failed to get data for this product<br /> Please try again or contact support.
            </span>
        );
        return (
            <span style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                    type="default"
                    size="small"
                    icon={props.expanded ? <UpOutlined /> : <DownOutlined />}
                    onClick={(e) => props.onExpand(props.record, e)}
                />
                {/* {props.record.error} */}
                {/* {props.record.scraperStatus} */}
                {/* {props.record.scraperStatus !== 'done' && (
					<Tooltip title={tooltipText}>
						<WarningTwoTone style={{ marginLeft: 10, fontSize: 15 }} twoToneColor="#eb2f96" />
					</Tooltip>
				)} */}
            </span>
        );
    };

    render() {
        const { data, loading, isDemo } = this.props;

        const amazonProducts = data && data.filter((l) => !(l.scraperError || l.scraperStatus === 'failed') && l.to && l.from && l.from.length > 0)

        return (
            <>
                {!loading && amazonProducts && amazonProducts.length === 0 && <Alert
                    style={{ textAlign: 'left', margin: '0 0 20px 0' }}
                    message="No Amazon Affiliate Links Found"
                    description={
                        <span>
                            We did not find any affilaite links. Try running the crawl again with 'Execute JavaScript'
                            toggled on in site's settings. <br />
                            Otherwise contact support.
                        </span>
                    }
                    type="warning"
                    showIcon
                />}
                 <Table
                    loading={loading}
                    expandedRowRender={this.expandedRowRender}
                    size="middle"
                    columns={this.getColumns()}
                    dataSource={amazonProducts}
                    rowKey={(item, index) => `${item.to}-${index}`}
                    expandIcon={this.expandIcon}
                    pagination={{
                        hideOnSinglePage: true,
                        pageSize: isDemo ? 10 : 20,
                        size: 'small',
                        showSizeChanger: false,
                    }}
                />
            </>
           
        );
    }
}

export default ReportTable;
